// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-package {
   margin: 50px 10px 10px;
   transition: background-color .3s, opacity .3s;

   display: flex;
   position: relative;
   flex: 1;
}

.flex-container {
   display: flex;
   flex-direction: column;
   flex: 1;
}

.flex-input {
   margin-top: 18px;
}

.flex-container2 {
   display: flex;
   padding: 0 24px;
}


.row {
   display: flex;
   flex: 1;
}

.container-column {
   display: flex;
   flex-direction: column;
}

.container-group {
   display: flex;
   flex-direction: column;
   flex: 1;
}

.flex {
   display: flex;
}

.flex-container {
   display: flex;
   max-width: 100%;
}

.check-box {
   padding: 0 5px 0 0;
}

input, textarea {
   outline: none;
   width: 100%;
}

span {
   color: rgba(0,0,0,0.87);
}

.radio-button {
   margin-left: 6px;
}

.error-show{
   margin-top:10px;
}
.input-field{
   width:100%;
}

.formate-radio-group {
   margin: 15px 10px;
}

.required:after {
   content:" *";
   color: red;
}

::ng-deep .mat-radio-button.mat-accent .mat-radio-inner-circle {
   background-color: #ffc107!important;
}

::ng-deep.mat-radio-button.mat-accent.mat-radio-checked .mat-radio-outer-circle {
   border-color:#ffc107!important;
}

::ng-deep.mat-checkbox-checked.mat-accent .mat-checkbox-ripple .mat-ripple-element {
   opacity: 0.03 !important;
   background-color: #ffc107!important;
}

::ng-deep.mat-checkbox-checked.mat-accent .mat-checkbox-background,.mat-checkbox-indeterminate.mat-accent .mat-checkbox-background {
   background-color: #ffc107;
}

.input-right {
   text-align: right;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
   -webkit-appearance: none;
   margin: 0;
}

/* Firefox */
input[type=number] {
   -moz-appearance: textfield;
}

.label-head {
   color: #777;
   display: block;
   font-size: 14px;
   font-weight: 400;
   margin: 15px 0 0;
   padding-bottom: 3px;
   text-align: right;
   width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/app/admin/package-manager/promotion-detail/promotion-detail.component.css"],"names":[],"mappings":"AAAA;GACG,sBAAsB;GACtB,6CAA6C;;GAE7C,aAAa;GACb,kBAAkB;GAClB,OAAO;AACV;;AAEA;GACG,aAAa;GACb,sBAAsB;GACtB,OAAO;AACV;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,aAAa;GACb,eAAe;AAClB;;;AAGA;GACG,aAAa;GACb,OAAO;AACV;;AAEA;GACG,aAAa;GACb,sBAAsB;AACzB;;AAEA;GACG,aAAa;GACb,sBAAsB;GACtB,OAAO;AACV;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,aAAa;GACb,eAAe;AAClB;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,aAAa;GACb,WAAW;AACd;;AAEA;GACG,uBAAuB;AAC1B;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,eAAe;AAClB;AACA;GACG,UAAU;AACb;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,YAAY;GACZ,UAAU;AACb;;AAEA;GACG,mCAAmC;AACtC;;AAEA;GACG,8BAA8B;AACjC;;AAEA;GACG,wBAAwB;GACxB,mCAAmC;AACtC;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG,iBAAiB;AACpB;;AAEA,gCAAgC;AAChC;;GAEG,wBAAwB;GACxB,SAAS;AACZ;;AAEA,YAAY;AACZ;GACG,0BAA0B;AAC7B;;AAEA;GACG,WAAW;GACX,cAAc;GACd,eAAe;GACf,gBAAgB;GAChB,gBAAgB;GAChB,mBAAmB;GACnB,iBAAiB;GACjB,WAAW;AACd","sourcesContent":[".container-package {\n   margin: 50px 10px 10px;\n   transition: background-color .3s, opacity .3s;\n\n   display: flex;\n   position: relative;\n   flex: 1;\n}\n\n.flex-container {\n   display: flex;\n   flex-direction: column;\n   flex: 1;\n}\n\n.flex-input {\n   margin-top: 18px;\n}\n\n.flex-container2 {\n   display: flex;\n   padding: 0 24px;\n}\n\n\n.row {\n   display: flex;\n   flex: 1;\n}\n\n.container-column {\n   display: flex;\n   flex-direction: column;\n}\n\n.container-group {\n   display: flex;\n   flex-direction: column;\n   flex: 1;\n}\n\n.flex {\n   display: flex;\n}\n\n.flex-container {\n   display: flex;\n   max-width: 100%;\n}\n\n.check-box {\n   padding: 0 5px 0 0;\n}\n\ninput, textarea {\n   outline: none;\n   width: 100%;\n}\n\nspan {\n   color: rgba(0,0,0,0.87);\n}\n\n.radio-button {\n   margin-left: 6px;\n}\n\n.error-show{\n   margin-top:10px;\n}\n.input-field{\n   width:100%;\n}\n\n.formate-radio-group {\n   margin: 15px 10px;\n}\n\n.required:after {\n   content:\" *\";\n   color: red;\n}\n\n::ng-deep .mat-radio-button.mat-accent .mat-radio-inner-circle {\n   background-color: #ffc107!important;\n}\n\n::ng-deep.mat-radio-button.mat-accent.mat-radio-checked .mat-radio-outer-circle {\n   border-color:#ffc107!important;\n}\n\n::ng-deep.mat-checkbox-checked.mat-accent .mat-checkbox-ripple .mat-ripple-element {\n   opacity: 0.03 !important;\n   background-color: #ffc107!important;\n}\n\n::ng-deep.mat-checkbox-checked.mat-accent .mat-checkbox-background,.mat-checkbox-indeterminate.mat-accent .mat-checkbox-background {\n   background-color: #ffc107;\n}\n\n.input-right {\n   text-align: right;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n   -webkit-appearance: none;\n   margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n   -moz-appearance: textfield;\n}\n\n.label-head {\n   color: #777;\n   display: block;\n   font-size: 14px;\n   font-weight: 400;\n   margin: 15px 0 0;\n   padding-bottom: 3px;\n   text-align: right;\n   width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
